export default function DesktopIcon({ icon: Icon, label, testid, onOpen, accent = false }) {
    return (
        <button
            data-testid={testid}
            onClick={onOpen}
            className="group flex flex-col items-center gap-1.5 w-[84px] py-2 rounded-lg hover:bg-white/10 focus:bg-white/15 transition-colors duration-150 outline-none"
        >
            <span
                className={`w-12 h-12 rounded-xl flex items-center justify-center border transition-transform duration-150 group-hover:scale-105 group-active:scale-95 ${
                    accent
                        ? "bg-vermilion border-vermilion text-white shadow-[0_8px_24px_rgba(230,59,46,0.35)]"
                        : "bg-[#23262d] border-white/15 text-neutral-200 shadow-[0_8px_24px_rgba(0,0,0,0.4)]"
                }`}
            >
                <Icon size={22} strokeWidth={1.8} />
            </span>
            <span className="text-[11px] font-medium text-neutral-200 text-center leading-tight [text-shadow:0_1px_3px_rgba(0,0,0,0.8)]">
                {label}
            </span>
        </button>
    );
}
